import React from "react";

function Section1() {
  return (
    <section className="csrd-section-1-container">
      <div className="all-section-header">
        Updapt CSRD Reporting, Analytics & Management Software
      </div>
      <div className="csrd-section-1-inner-container">
        <div className="left-section-1">
          <div className="left-section-1-inner-container">
            <h2 className="section-1-heading">Double Materiality Assessment</h2>
            <p className="section-1-description">
              <div>
                Integrated methodology to assess both financial materiality
                (impact on business performance) and impact materiality
                (business impact on society and the environment).
              </div>
              <div>
                Built on CSRD-defined sustainability topics with the flexibility
                to incorporate sector-specific issues from other global
                frameworks (SASB, TCFD, etc.).
              </div>
              <div>
                Automatically generate Impact, Risk, and Opportunity (IRO),
                ensuring alignment with CSRD and ESRS requirements.
              </div>
              <div>
                Auto-generated, interactive materiality matrix visualising issue
                prioritization based on stakeholder input and business
                relevance.
              </div>
            </p>
          </div>
        </div>
        <div className="right-section-1">
          <div className="image-container">
            <img
              src={require("../../../../assets/Solution/csrd/dma_1.svg")}
              className="image_1"
              alt="background"
            />
            <img
              src={require("../../../../assets/Solution/csrd/bg_1.svg")}
              className="bg_1"
              alt="double materiality"
            />
            <div className="datatrack-grey-circle-right"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section1;
